export default "__VITE_ASSET__BqVdFzhS__"